<template>
  <div>
    <v-btn color="primary"
           @click.stop="dialog = true"
           class="my-2"
    >
      <v-icon class="margin-right-small">mdi-move-resize</v-icon>
      Set overlay position
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="1500"
              persistent
    >
      <OverlayPositionForm
        v-if="dialog"
        :overlay="localOverlay"
        @updateOverlayPosition="updateOverlayPosition"
        @cancel="dialog = false"
      ></OverlayPositionForm>
    </v-dialog>
  </div>
</template>

<script>
import {HubConnection} from "@microsoft/signalr";
import {DeepCopy} from "../../services/deep-copy";
import {ConnectionService} from "../../services/connection.service";
import OverlayPositionForm from "./OverlayPositionForm";
import axios from "axios";

export default {
  name:       "UpdateOverlayForm",
  components: {
    OverlayPositionForm
  },
  props: {
    connection: HubConnection,
    overlay:    Object,
  },
  data: function () {
    return {
      dialog:       false,
      localOverlay: DeepCopy(this.overlay),
      rules:        {
        required: (value) => !!value || "Required."
      },
    };
  },
  watch: {
    overlay(newOverlay) {
      this.localOverlay = DeepCopy(newOverlay);
    },
  },
  mounted() {
    this.localOverlay = DeepCopy(this.overlay);
  },
  methods: {
    updateOverlayPosition(leftRatio, topRatio, widthRatio, aspectRatioValue) {
      const url = `/api/Settings/UpdateOverlayPositionAndWidth?topRatio=${topRatio}&leftRatio=${leftRatio}&widthRatio=${widthRatio}&aspectRatio=${aspectRatioValue}`;
      axios
        .post(ConnectionService.getUrl(url))
        .then((response) => {
          if (response.data.resultKind === "Success") {
            this.$emit("overlay-updated", response.data.entity);
          } else {
            this.$emit("failure", response.data.reason);
          }
        })
        .catch((reason) => {
          this.$emit("failure", reason);
        });
      this.dialog = false;
    },
  },
};
</script>
